module.exports = __webpack_public_path__ + "img/Trans.987c20e6.gif";